import { TransactionAmount } from './TransactionAmount';
import { Card, Typography } from '@heroui/react';
import { Icon } from '@iconify/react';
import type { SalesTransaction } from '@/api/models';
import { RefLabel } from '@/components';
import { getNodeTestIdProp } from '@/utils';
import { TransactionDiscountChip } from './TransactionDiscountChip';
import { TransactionDiscountNote } from './TransactionDiscountNote';

type TransactionCartLineProps = { item: SalesTransaction['cart'][number] };
export const TransactionCartLine = ({ item }: TransactionCartLineProps) => (
    <li {...getNodeTestIdProp(`transaction-detail-cart-item-${item.barcode}`)}>
        <Card variant="secondary" className="flex-row items-center gap-3 p-3">
            <Icon
                aria-hidden="true"
                className="size-4 shrink-0 text-muted"
                icon="solar:box-minimalistic-bold-duotone"
            />
            <div className="min-w-0 flex-1">
                <Typography
                    type="body-sm"
                    truncate
                    {...getNodeTestIdProp(
                        `transaction-detail-cart-item-name-${item.barcode}`,
                    )}
                >
                    <RefLabel
                        archived={item.archived}
                        deleted={item.deleted}
                        id={item.productId}
                        name={item.name}
                    />
                </Typography>
                <div className="mt-0.5 flex flex-wrap items-center gap-2">
                    <Typography
                        type="body-xs"
                        color="muted"
                        {...getNodeTestIdProp(
                            `transaction-detail-cart-item-meta-${item.barcode}`,
                        )}
                    >
                        <TransactionAmount amountTetri={item.priceTetri} />
                        {` × ${item.quantity}`}
                    </Typography>
                    {item.discount && (
                        <span
                            {...getNodeTestIdProp(
                                `transaction-detail-cart-item-discount-${item.barcode}`,
                            )}
                        >
                            <TransactionDiscountChip
                                discount={item.discount}
                                scope="line"
                            />
                        </span>
                    )}
                </div>
                {item.discount?.note && (
                    <div
                        {...getNodeTestIdProp(
                            `transaction-detail-cart-item-note-${item.barcode}`,
                        )}
                    >
                        <TransactionDiscountNote note={item.discount.note} />
                    </div>
                )}
            </div>
            <div className="flex shrink-0 flex-col items-end gap-1">
                <Typography type="body-sm" weight="bold">
                    <span
                        {...getNodeTestIdProp(
                            `transaction-detail-cart-item-total-${item.barcode}`,
                        )}
                    >
                        <TransactionAmount amountTetri={item.totalTetri} />
                    </span>
                </Typography>
                {item.listTotalTetri !== item.totalTetri && (
                    <Typography type="body-xs" color="muted">
                        <s>
                            <span
                                {...getNodeTestIdProp(
                                    `transaction-detail-cart-item-list-total-${item.barcode}`,
                                )}
                            >
                                <TransactionAmount
                                    amountTetri={item.listTotalTetri}
                                />
                            </span>
                        </s>
                    </Typography>
                )}
            </div>
        </Card>
    </li>
);
